import { Container, Loader, Title } from "@mantine/core";
import {useFirestoreDocumentData, useFirestoreDocumentMutation} from "@react-query-firebase/firestore";
import {collection, doc, arrayUnion, arrayRemove} from "firebase/firestore";
import { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import SubscribeImage from '../assets/subscribe.svg';
import ButtonCustom from '../components/Inputs/Button';
import { auth, firestore } from "../firebase";

export default function BoardNotification({board}) {
    const [user] = useAuthState(auth);
    const [emailOpened, setEmailOpened] = useState(false);

    const collectionRef = collection(firestore, 'users');
    const ref = doc(collectionRef, user?.uid || "a");
    const userDocument = useFirestoreDocumentData(["users", user?.uid], ref, {subscribe: true}, {enabled: !!user?.uid});

    const userData = userDocument?.data;

    const subscribed = userData?.[`subscribed_boards`]?.includes(board.data.id);
    const mutationMerge = useFirestoreDocumentMutation(ref, {
        merge: true,
    });

    const unsubscribe = () => {

        mutationMerge.mutate({
            [`subscribed_boards`]: arrayRemove(board.data.id)
        }).then(() => {
            userDocument.refetch();
        })
    }
    const subscribe = () => {
        if ( subscribed) {
            return unsubscribe();
        }

       mutationMerge.mutate({
           [`subscribed_boards`]: arrayUnion(board.data.id)
       }).then(() => {
           userDocument.refetch();
       })
    }
    useEffect(() => {

        if (userData) {

            let c = setTimeout(() => {

                if (!subscribed && !emailOpened) {
                    setEmailOpened(true);
                }
            }, 2000)
            return () => clearTimeout(c);
        }

    }, [userData, subscribed])

    useEffect(() => {
        userDocument.refetch();
    }, [mutationMerge.isLoading]);

    return (
        <>
            <Container fluid={true} className={'mt-10 pb-10'} id="contentGallery">
                <div className="w-full max-w-[700px] mx-auto">
                    <div className="w-full max-w-[175px] mb-6 mx-auto">
                        <img src={SubscribeImage} alt="subscribe" className="w-full h-full" />
                    </div>
                    <Title align="center" style={{marginBottom:'0.5rem',color:'#3c3c3c'}} order={1}>Abonează-te la plansă </Title>
                    <Title align="center" style={{marginBottom:'1.5rem',color:'#3c3c3c'}} order={5}>Iți trimitem un SMS gratuit când planșa este publicată!</Title>
                    {mutationMerge.isLoading ?
                        <div className="flex justify-center items-center w-full">
                            <Loader size={40} />
                        </div>
                    :
                        <ButtonCustom 
                            style={{backgroundColor: !subscribed ? 'rgb(96 165 250)' : 'rgb(248 113 113)'}}
                            className="mx-auto mt-4 w-full max-w-[300px] font-[600] bg-red-400"
                            label={!subscribed ? "ABONEAZĂ-TE" : "DEZABONEAZĂ-TE"} 
                            onClick={() => subscribe()}  
                        />}
                </div>
            </Container>
        </>
    )
}